<template>
	<div class="expandable-text">
		<header>
			{{ title }}
			<i
				ref="refIcon"
				:class="['icon', open ? 'icon-less' : 'icon-more']"
				@click="open = !open"
			/>
		</header>
		<div v-if="open" ref="refValue">
			{{ value }}
		</div>
		<PopperPosition
			:trackedRefName="$refs.refIcon"
			:popoverRefName="$refs.refValue"
			placement="bottom-start"
			:popperVisible="open"
			strategy="fixed"
		/>
	</div>
</template>

<script>
import PopperPosition from '@/components/visual/popper-position';

export default {
	name: 'ExpandableText',
	components: {
		PopperPosition
	},
	props: {
		title: {
			type: String,
			default: ''
		},
		value: {
			type: [String, Number],
			default: null
		}
	},
	data() {
		return {
			open: false
		};
	}
};
</script>

<style lang="scss" scoped>
.expandable-text {
	display: inline-flex;
	flex-direction: column;
}
</style>
